"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeManagerProvider = exports.ThemeManagerContext = void 0;
const tslib_1 = require("tslib");
const lift_brand_token_provider_1 = require("@lift/design-system-react-web/dist/contexts/lift-brand-token.provider");
const react_1 = tslib_1.__importStar(require("react"));
const theme_provider_1 = require("../theme/theme.provider");
exports.ThemeManagerContext = (0, react_1.createContext)(null);
const ThemeManagerProvider = ({ brand, children }) => {
    const [altoContraste, setAltoContraste] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setAltoContraste(JSON.parse(localStorage.getItem('SAVATemplateHighContrast')));
    }, []);
    const toggleAltoContraste = (0, react_1.useCallback)(() => {
        localStorage.setItem('SAVATemplateHighContrast', `${!altoContraste}`);
        location.reload();
    }, [altoContraste]);
    return (react_1.default.createElement(exports.ThemeManagerContext.Provider, { value: {
            toggleAltoContraste,
            altoContraste,
        } },
        react_1.default.createElement(lift_brand_token_provider_1.LiftBrandTokenProvider, { brand: brand, template: altoContraste ? 'high-contrast' : 'default' },
            react_1.default.createElement(theme_provider_1.ThemeProvider, null, children))));
};
exports.ThemeManagerProvider = ThemeManagerProvider;
